import { initHeroSlider } from "./heroSlider";
import { initLogoScrollAnimation } from "./logo";
import { initDrawLines } from "./drawLines";
import { initOfferCarousels } from "./carousel";
import {initProductCarousel} from "./productCarousel";
import {initAccordions} from "./accordion";
import {initFooter} from "./footer";
import {initProductGallery, initProductGalleryPhotoSwipe} from "./productGallery";
import {initShopDetails} from "./ShopDetails";
import {initComments} from "./comments";
import {initCopyURL} from "./copyUrl";
import {initBlog} from "./blog";
import {initMiniCart} from "./miniCart";
import { initLoadMore } from "./loadMore";
import { initBlogFilters } from "./blog-filters";
import { initWooCommerceFilterAccordion } from "./accordion";
import { initMegaMenu } from "./megaMenu";
import { initCounter } from "./counter";
import { initLightBoxGallery } from "./lightBoxGallery";
import { initHeaderMenuToggle } from "./headerMenuToggle";
import { initQuantity } from "./quantity";
import { initAccountNavToggle } from "./accountNavToggle";
import {initVariationModal} from "./variationModal";
import {initCategories} from "./categories";


const init = () => {
    initHeroSlider();
    initLogoScrollAnimation();
    initDrawLines();
    initOfferCarousels();
    initProductCarousel()
    initAccordions()
    initFooter()
    initProductGallery()
    initProductGalleryPhotoSwipe()
    initShopDetails()
    initComments()
    initCopyURL()
    initBlog()
    initMiniCart()
    initLoadMore()
    initBlogFilters()
    initWooCommerceFilterAccordion()
    initMegaMenu()
    initCounter()
    initLightBoxGallery()
    initHeaderMenuToggle()
    initQuantity()
    initAccountNavToggle()
    initVariationModal()
    initCategories()
}

document.addEventListener('DOMContentLoaded', () => {
    init()
});
